
import { Shell } from "@/components/layout/Shell";
import { CurrencyForm } from "@/components/currencies/CurrencyForm";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { useCurrencies } from "@/hooks/useCurrencies";
import { Currency } from "@/lib/types";
import { useTranslation } from "react-i18next";

export default function CurrencyCreatePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { useCreateCurrencyMutation } = useCurrencies();
  const createCurrency = useCreateCurrencyMutation();

  const handleSuccess = (currency: Currency) => {
    navigate("/currencies");
  };

  return (
    <Shell>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">{t('createNewCurrency')}</h1>
          <p className="text-muted-foreground">
            {t('addNewCurrency')}
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>{t('currencyDetails')}</CardTitle>
            <CardDescription>
              {t('enterCurrencyDetails')}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <CurrencyForm onSuccess={handleSuccess} />
          </CardContent>
        </Card>
      </div>
    </Shell>
  );
}
